var _ellipse, _ellipse2, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataSystems = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9944,
    cy: 4.47684,
    rx: 3.14286,
    ry: 3.14286,
    fill: "#071A24"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9944,
    cy: 27.5237,
    rx: 3.14286,
    ry: 3.14286,
    fill: "#071A24"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.1032,
    cy: 10.4689,
    r: 3.14286,
    transform: "rotate(61.3122 26.1032 10.4689)",
    fill: "#071A24"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.88492,
    cy: 21.5314,
    r: 3.14286,
    transform: "rotate(61.3122 5.88492 21.5314)",
    fill: "#071A24"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 3.14286,
    transform: "matrix(-0.480036 0.877249 0.877249 0.480036 5.8848 10.4689)",
    fill: "#071A24"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 3.14286,
    transform: "matrix(-0.480036 0.877249 0.877249 0.480036 26.1031 21.5314)",
    fill: "#071A24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9941 10.2461V21.753",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9771 13.123L11.0119 18.8765",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9771 18.877L11.0119 13.1235",
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataSystems);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data_systems.46829e164740adb81f74f14f18f4a223.svg";